import { CUSTOMER_TYPE_BUSINESS, CUSTOMER_TYPE_INDIVIDUAL } from 'shared/constants'

export const DOCUMENT_TYPES = [
    {
        label: 'CPF',
        value: CUSTOMER_TYPE_INDIVIDUAL,
    },
    {
        label: 'CNPJ',
        value: CUSTOMER_TYPE_BUSINESS,
    },
]

export const DOCUMENT_TYPE_NUMBER_PATTERN = {
    [CUSTOMER_TYPE_INDIVIDUAL]: /^\d{3}\.?\d{3}\.?\d{3}-?\d{2}$/,
    [CUSTOMER_TYPE_BUSINESS]: /^\d{2}\.?\d{3}\.?\d{3}\/?\d{4}-?\d{2}$/,
}

export const DOCUMENT_TYPE_MASK = {
    [CUSTOMER_TYPE_INDIVIDUAL]: 'XXX.XXX.XXX-XX',
    [CUSTOMER_TYPE_BUSINESS]: 'XX.XXX.XXX/XXXX-XX',
}
